// src/utils/api.js

import axios from "axios";

const baseurl = process.env.REACT_APP_BASE_URL || process.env.BASE_URL || 'http://192.168.29.251:5008';

// Create axios instance
const API = axios.create({
  baseURL: baseurl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
export default API;